export type CreditTxn = { amount: number | null; type: string; created_at: string | null };

const ADDS_SUBSCRIPTION = new Set(['subscription_seat', 'plan_renewal']);
const SPENDS = new Set(['generation_cost', 'marketplace_purchase']);

/**
 * Gastos que saíram do saldo avulso. O plano é consumido primeiro; o que passa disso
 * sai de purchased_credits. O total é esse gasto mais o que ainda resta.
 */
export function avulsosFromLedger(rows: CreditTxn[], remaining: number): { spent: number; total: number } {
  let subscription = 0;
  let spent = 0;
  const ordered = [...rows].sort((a, b) => (a.created_at || '').localeCompare(b.created_at || ''));
  for (const row of ordered) {
    const amount = Number(row.amount) || 0;
    if (row.type === 'subscription_grant') {
      subscription = Math.max(0, subscription + amount);
    } else if (ADDS_SUBSCRIPTION.has(row.type) && amount > 0) {
      subscription += amount;
    } else if (SPENDS.has(row.type) && amount < 0) {
      let cost = -amount;
      const fromPlan = Math.min(subscription, cost);
      subscription -= fromPlan;
      spent += cost - fromPlan;
    }
  }
  const round2 = (n: number) => Math.round(n * 100) / 100;
  const spentRounded = round2(Math.max(0, spent));
  const total = round2(spentRounded + Math.max(0, remaining));
  return { spent: spentRounded, total };
}
